module.exports = __webpack_public_path__ + "img/bret.090304d3.png";